import { Box, IconButton, Link, Typography } from "@mui/material";
import React, { useState } from "react";
import parse from "html-react-parser";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";

import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";

import { TreeView } from '@mui/x-tree-view';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SquareIcon from '@mui/icons-material/Square';
import RedditRecursiveComment from "./RedditRecursiveComment";

const RedditSubmissionCard = (props) => {
  const { submission, confidenceFilter } = props;

  const [commentsOpen, setCommentsOpen] = useState(false);

  return (
    <Card variant="outlined" sx={{ display: "flex", flexDirection: "column" }}>
      <CardHeader
        title={
          <Box sx={{display: 'flex',flex:1, alignItems:'center'}}>
           <SquareIcon sx={{marginRight:1}} color='primary' fontSize='small'/>
          <Typography variant="h6">
            <Link href={submission.url} target={"_blank"}>
              {submission.submission}
            </Link>
          </Typography>
          </Box>
         
        }
      ></CardHeader>
      <CardContent>
        <Typography>
          {submission.text_html && parse(submission.text_html)}
        </Typography>
      </CardContent>
      <CardActions>
        <IconButton onClick={() => setCommentsOpen(!commentsOpen)}>
          <ModeCommentOutlinedIcon />
          {submission.number_of_comments}
        </IconButton>
      </CardActions>
      {commentsOpen && (
        <TreeView
          aria-label="file system navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{ flexGrow: 1, overflowY: "auto" }}
        >
          {submission.comments.map((comment) => {
            return (
              <RedditRecursiveComment
                key={comment.id}
                comment={comment}
                confidenceFilter={confidenceFilter}
              />
            );
          })}
        </TreeView>
      )}
    </Card>
  );
};

export default RedditSubmissionCard;
